"use strict";
var PREFIX = '@SHOWUP/';
exports.ADD_ALERT_NOTIFICATION = PREFIX + "ADD_ALERT_NOTIFICATION";
exports.ADD_ERROR_NOTIFICATION = PREFIX + "ADD_ERROR_NOTIFICATION";
exports.CLEAR_NOTIFICATION = PREFIX + "CLEAR_NOTIFICATION";



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/actions/actionTypes.ts
 ** module id = 242
 ** module chunks = 0
 **/